import { __extends } from "tslib";
import { PrimaryPopover, Icon } from '@wix/answers-ui-libby';
import { ArticleType, AppNavigator, AppState, allTicketsViewId } from '@wix/answers-api';
import ArticleManageIcon from '../../icons/article-manage.svg';
import ArticleStatsIcon from '../../icons/article-stats.svg';
import * as React from 'react';
var ArticleContextView = /** @class */ (function (_super) {
    __extends(ArticleContextView, _super);
    function ArticleContextView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isStatsOpen: false
        };
        _this.compTranslate = function (key, params) {
            if (params === void 0) { params = {}; }
            return _this.props.translate("article.".concat(key), params);
        };
        _this.stopClickPropagation = function (e) {
            e.stopPropagation();
        };
        _this.showArticleStats = function (e) {
            e.stopPropagation();
            _this.setState({ isStatsOpen: true });
        };
        _this.hideArticleStats = function (e) {
            if (e) {
                e.stopPropagation();
            }
            _this.setState({ isStatsOpen: false });
        };
        _this.counterElement = function (translateKey, value, articleId) {
            var _a;
            if (articleId === void 0) { articleId = ''; }
            var _b = _this.props, commonTrans = _b.commonTrans, contextData = _b.contextData;
            var articleLocale = contextData ? (_a = contextData.articleContext) === null || _a === void 0 ? void 0 : _a.article.locale : null;
            var filters = encodeURIComponent(JSON.stringify({
                relatedArticleIds: [articleId],
            }));
            var relatedUrl = articleId.length
                ? "/app/helpdesk/one-inbox?filters=".concat(filters, "&savedFilter=").concat(allTicketsViewId, "&locale=").concat(articleLocale)
                : '';
            var counterComp = !relatedUrl ? (React.createElement("span", { className: "counter-element ".concat(translateKey) },
                React.createElement("span", { className: 'count-value' }, value),
                React.createElement("span", { className: 'count-label' }, commonTrans(translateKey)))) : (React.createElement("a", { href: relatedUrl, className: "counter-element ".concat(translateKey), target: '_blank' },
                React.createElement("span", { className: 'count-value' }, value),
                React.createElement("span", { className: 'count-label' }, commonTrans(translateKey))));
            return value >= 0 ? counterComp : null;
        };
        return _this;
    }
    ArticleContextView.prototype.render = function () {
        var props = this.props;
        var commonTrans = this.props.commonTrans;
        var compTranslate = this.compTranslate;
        var articleContext = props.contextData ? props.contextData.articleContext : null;
        var articleType = articleContext ? articleContext.article.type : null;
        var articleId = articleContext ? articleContext.article.id : '';
        var isArticleType = articleContext ? articleType === ArticleType.ARTICLE : false;
        var isNotArticleType = articleType ? (articleType === ArticleType.FEATURE_REQUEST ||
            articleType === ArticleType.KNOWN_ISSUE) : false;
        var counters = articleContext ? articleContext.counters : null;
        var locale = articleContext ? "?locale=".concat(articleContext.article.locale) : null;
        var manageArticleUrl = AppNavigator.getAppLink(AppState.HC_ARTICLE, articleId) + locale;
        var countersComp = !!articleContext && !!counters && (React.createElement("div", { className: 'counters-container' },
            this.counterElement('followers', counters.followers),
            this.counterElement('linked-tickets', articleContext.article.relatedTicketsCount, articleId),
            isArticleType ? this.counterElement('helpful', counters.helpful) : null,
            isArticleType ? this.counterElement('unhelpful', counters.unhelpful) : null,
            isNotArticleType ? this.counterElement('votes', counters.votes) : null));
        var articleStatsBody = !!articleContext && (React.createElement("div", { className: 'article-stats-body', onClick: this.stopClickPropagation },
            React.createElement("div", { className: 'times-container' },
                React.createElement("div", { className: 'agent-times updated-time' },
                    React.createElement("span", { className: 'time-label' }, commonTrans('updated')),
                    React.createElement("span", { className: 'time-value' }, articleContext.updated)),
                React.createElement("div", { className: 'agent-times created-time' },
                    React.createElement("span", { className: 'time-label' }, commonTrans('created')),
                    React.createElement("span", { className: 'time-value' }, articleContext.created))),
            counters ? countersComp : null));
        return articleContext ? (React.createElement("div", { className: 'article-context-container' },
            React.createElement(PrimaryPopover, { className: 'article-popover', body: articleStatsBody, isOpen: this.state.isStatsOpen, onOuterAction: this.hideArticleStats },
                React.createElement("button", { className: 'article-stat-btn', onClick: this.showArticleStats },
                    React.createElement(Icon, { icon: ArticleStatsIcon }),
                    compTranslate('state.title'))),
            React.createElement("span", { className: 'context-divider' }),
            React.createElement("a", { className: 'article-manage', href: manageArticleUrl, target: '_blank', onClick: this.stopClickPropagation },
                React.createElement(Icon, { icon: ArticleManageIcon }),
                compTranslate('manage.title')))) : null;
    };
    return ArticleContextView;
}(React.PureComponent));
export { ArticleContextView };
//# sourceMappingURL=article-context-view.comp.js.map